import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Preload SOLO de las rutas marcadas con `data: { preload: true }` (los flujos
 * frecuentes desde el home: dashboard, goals, general-balance, deposit).
 * Reemplaza a PreloadAllModules, que tras la primera navegación descargaba los
 * ~30 módulos lazy del portal en paralelo (blog, kyc, contract, ibkr…),
 * compitiendo por ancho de banda y main thread con los datos del dashboard.
 * Las rutas no marcadas se cargan on-demand al navegar, como cualquier lazy.
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data?.['preload'] ? load() : of(null);
  }
}
